<template>
  <v-container pa-0>
    <v-layout>
      <v-container class="justify">
        <v-flex xs12 mb-2>
          <h2 class="font-weight-light secondary--text" v-text="page_title"></h2>
          <v-spacer></v-spacer>
          <span
            class="mt-2 secondary--text"
          >{{ months[getDate.getMonth()] }} {{ getDate.getDate() }}, {{getDate.getFullYear()}}</span>
        </v-flex>
        <template>
          <v-card>
            <v-card-title>
              <v-layout row wrap>
                <div>
                  <h3 class="font-weight-regular">ROUTE MARSHALS</h3>
                </div>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-layout>
            </v-card-title>
            <v-data-table :headers="headers" :items="marshals" :search="search">
              <template slot="items" slot-scope="props">
                <tr class="pointer" @click="toroute(props.item.link)">
                  <td>
                    <h3 class="font-weight-regular" v-text="props.item.name"></h3>
                  </td>
                  <td class="text-xs-center" v-text="props.item.state"></td>
                  <td class="text-xs-center" v-text="props.item.route"></td>
                  <td class="text-xs-center" v-text="props.item.merchants"></td>
                  <td class="text-xs-center" v-text="props.item.status"></td>
                </tr>
              </template>
              <v-alert
                slot="no-results"
                :value="true"
                color="error"
                icon="warning"
              >Your search for "{{ search }}" route marshal has no results.</v-alert>
            </v-data-table>
          </v-card>
        </template>
      </v-container>
    </v-layout>
  </v-container>
</template>
<script>
import AdminLayout from "../../../layouts/admin"

export default {
  name: "Schedule",
  data() {
    return {
      page_title: "Route Marshals",
      getDate: new Date(),
      search: "",
      headers: [
        {
          text: "Route Marshal",
          align: "left",
          value: "name"
        },
        { text: "State", value: "state" },
        { text: "Route", value: "rm" },
        { text: "Merchants", value: "merchants" },
        { text: "Status", value: "status" }
      ],
      marshals: [
        {
          name: "Abosede Adebayo",
          route: "Ketu",
          state: "Kano",
          merchants: 100,
          link: "/admin/route-marshals/1",
          status: "Online"
        }
      ],
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ]
    }
  },
  methods: {
    toroute(route) {
      this.$router.push(route)
    }
  },
  created() {
    this.$emit("update:layout", AdminLayout)
  }
}
</script>